import React from 'react';
import Icon from '../components/Icon';
import { APP_VERSION, RELEASE_DATE, APP_INFO } from '../version';
import { fmtDate } from '../utils/date';
import { useLanguage } from '../context/LanguageContext';
import './About.css';

/**
 * Sistem haqqında — versiya, müəlliflik və istifadə şərtləri.
 * Məzmun src/version.js-dən gəlir ki, versiya bir yerdən idarə olunsun.
 */
export default function About() {
  const { lang } = useLanguage();

  const facts = [
    { label: 'Versiya',       value: 'v' + APP_VERSION,                   icon: 'zap' },
    { label: 'Buraxılış',     value: fmtDate(RELEASE_DATE, lang),         icon: 'calendar' },
    { label: 'Müəllif',       value: APP_INFO.author,                     icon: 'users' },
    { label: 'Təşkilat',      value: APP_INFO.org,                        icon: 'building' },
  ];

  const modules = [
    'Şöbələr və daxili sorğular',
    'Təchizat və təsdiq zənciri',
    'Anbar və stok uçotu',
    'Məzuniyyət və icazələr',
    'Şagird qeydiyyatı və qəbul',
    'Müəllim və sinif idarəetməsi',
    'Daxili çat və bildirişlər',
    'Elanlar və analitika',
  ];

  const tech = [
    { k: 'İnterfeys',         v: 'React 18 · PWA' },
    { k: 'Server',            v: 'Node.js · Express' },
    { k: 'Verilənlər bazası', v: 'MySQL' },
    { k: 'Real vaxt',         v: 'Socket.IO' },
    { k: 'Giriş',             v: 'Microsoft Entra ID (SSO) · JWT' },
    { k: 'Bildiriş',          v: 'Microsoft Graph API · Web Push' },
  ];

  return (
    <div className="ab-page">
      <section className="ab-hero">
        <div className="ab-hero-badge"><Icon name="school" size={34} /></div>
        <div className="ab-hero-text">
          <h1 className="ab-hero-title">{APP_INFO.name}</h1>
          <p className="ab-hero-sub">{APP_INFO.org}</p>
        </div>
        <span className="ab-hero-ver">v{APP_VERSION}</span>
      </section>

      <div className="ab-facts">
        {facts.map(f => (
          <div key={f.label} className="ab-fact">
            <span className="ab-fact-icon"><Icon name={f.icon} size={17} /></span>
            <div className="ab-fact-body">
              <div className="ab-fact-label">{f.label}</div>
              <div className="ab-fact-value">{f.value}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="ab-grid">
        <section className="ab-card">
          <h2 className="ab-card-title">Müəllif hüququ</h2>
          <p className="ab-copy">
            © {APP_INFO.copyrightYear} <b>{APP_INFO.author}</b>. Bütün hüquqlar qorunur.
          </p>
          <p className="ab-text">
            Proqram müəllifin şəxsi təşəbbüsü ilə, öz vəsaiti və öz texniki
            infrastrukturu hesabına hazırlanmışdır. Proqrama dair müəlliflik və
            əmlak hüquqları müəllifə aiddir.
          </p>
          <p className="ab-text">
            {APP_INFO.org} Proqramdan öz təhsil və inzibati fəaliyyətində
            <b> müddətsiz və əvəzsiz</b> istifadə hüququna malikdir. Sistemdə
            saxlanılan bütün məlumatlar (şagird, əməkdaş, sənəd) Kompleksin
            mülkiyyətidir.
          </p>
          <p className="ab-note">
            Mənbə kodunun üçüncü şəxslərə verilməsi, yayılması və Kompleksdən
            kənar quraşdırılması müəllifin yazılı icazəsi olmadan qadağandır.
          </p>
        </section>

        <section className="ab-card">
          <h2 className="ab-card-title">Əlaqə</h2>
          <div className="ab-person">
            <div className="ab-person-avatar">{APP_INFO.author.charAt(0)}</div>
            <div>
              <div className="ab-person-name">{APP_INFO.author}</div>
              <div className="ab-person-role">{APP_INFO.authorRole}</div>
            </div>
          </div>
          <a className="ab-mail" href={'mailto:' + APP_INFO.authorEmail}>
            <Icon name="message" size={15} />
            {APP_INFO.authorEmail}
          </a>
          <p className="ab-note">
            Texniki problem bildirərkən versiya nömrəsini (<b>v{APP_VERSION}</b>)
            qeyd etsəniz, problem daha tez aydınlaşar.
          </p>
        </section>

        <section className="ab-card">
          <h2 className="ab-card-title">Modullar</h2>
          <ul className="ab-list">
            {modules.map(m => (
              <li key={m}><Icon name="check" size={14} /> {m}</li>
            ))}
          </ul>
        </section>

        <section className="ab-card">
          <h2 className="ab-card-title">Texniki quruluş</h2>
          <dl className="ab-tech">
            {tech.map(t => (
              <div key={t.k} className="ab-tech-row">
                <dt>{t.k}</dt>
                <dd>{t.v}</dd>
              </div>
            ))}
          </dl>
        </section>
      </div>

      <p className="ab-footer">
        {APP_INFO.name} · v{APP_VERSION} · {fmtDate(RELEASE_DATE, lang)}
      </p>
    </div>
  );
}
